import React, { useEffect } from 'react'
import AppRoutes from './routes'
import { useAppDispatch } from './redux/app/hooks'
import { getFreshBasketRedux } from './redux/slices/basket/basketSlice'
import { setUser } from './redux/slices/user/userSlice'
import { changeTheme } from './redux/slices/theme/themeSlice'
import { ClientStorage } from './base/storage'
import { ConfigHelper } from './base/constants'
import { setSearchHistory } from './redux/slices/searchHistory/searchHistorySlice'
import { getFavoriteProductListRedux } from './redux/slices/favoriteProduct/favoriteProductSlice'
import { getThemeFromStorage } from './base/utils/dataHelper'
import ChatWidget from './components/ChatWidget'
import { isPublicCustomerPath } from './routes/publicPaths'
import './default.scss'

function App() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!ClientStorage.hasItem(ConfigHelper.INDEXPAZAR_USER_DATA)) {
      return
    }
    if (`${window.location.pathname}` === "/xml/xml-request") {
      return
    }
    // Kart onay sayfası oturumsuzdur; eskimiş bayi oturumuyla yapılan çağrı giriş sayfasına atar.
    if (isPublicCustomerPath(window.location.pathname)) {
      return
    }

    if (`${window.location.pathname}` != "/AppleNetChannel") {
      dispatch(getFreshBasketRedux())
      dispatch(getFavoriteProductListRedux())
    }

    dispatch(setUser())
    // dispatch(changeTheme(getThemeFromStorage()));
    dispatch(setSearchHistory(''))
  }, [])

  return (
    <div>
      <AppRoutes />
      <ChatWidget />
    </div>
  )
}

export default App
